import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const WhyChooseSubscriptionSectionSkeleton = () => (
  <Grid container spacing={{ lg: 6, sm: 3 }}>
    {[...Array(6).keys()].map((item) => (
      <Grid item xl={4} lg={6} md={12} sm={12} key={item}>
        <Skeleton variant="rectangular" height="80px" width="80px" />
        <Skeleton variant="text" height={60} width="80%" />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="100%" height={20} />
      </Grid>
    ))}
  </Grid>
);
export { WhyChooseSubscriptionSectionSkeleton };
